import { StandardEvents } from '@shopify/events';

if (!customElements.get('product-template-notice')) {
  class ProductTemplateNotice extends HTMLElement {
    #abortController;

    connectedCallback() {
      this.#abortController = new AbortController();
      // Gleiches Ziel wie Horizons product-form: nächste Section/Dialog/Produktkarte
      const target = this.closest('.shopify-section, dialog, product-card');
      target?.addEventListener(StandardEvents.productSelect, this.#onProductSelect, {
        signal: this.#abortController.signal,
      });
    }

    disconnectedCallback() {
      this.#abortController?.abort();
    }

    #onProductSelect = async (event) => {
      // Nicht auf Varianten-Wechsel fremder Produktkarten (z. B. Empfehlungen) reagieren
      const sourceCard = event.target?.closest('product-card');
      if (sourceCard && !sourceCard.contains(this)) return;

      try {
        // Horizon liefert das neu gerenderte HTML über das Promise des Events
        const { detail } = await event.promise;
        if (!detail?.html) return;

        let html = detail.html;
        if (typeof html === 'string') {
          html = new DOMParser().parseFromString(html, 'text/html');
        }

        // Unser bereits serverseitig korrekt berechnetes Element aus dem neuen HTML holen
        const incoming = html.querySelector('#' + CSS.escape(this.id));
        if (incoming) {
          this.innerHTML = incoming.innerHTML;
        }
      } catch (error) {
        // Varianten-Wechsel abgebrochen o. Ä. – ignorieren
      }
    };
  }

  customElements.define('product-template-notice', ProductTemplateNotice);
}
